$(() => {
  const key = 'enable-on-change';
  $(`[data-${key}]`).on('change', function () {
    $($(this).data(key)).prop('disabled', false);
  });
});
